module.exports = __webpack_public_path__ + "static/MUSICBG-605dc627f836ce16858b8251d61a6545.jpg";